import { BookOpenIcon } from 'components/forms/CourseSearch/components';
import { RoundedInput } from 'components/common/RoundedInput';
import { SearchIconContainer } from 'components/common/SearchIconContainer';
import { Spin } from 'antd';
import { XIcon } from 'components/common/XIcon';
import { useCourseSearchStore } from 'store/course-search';
import useSelectedSourceInstitution from 'hooks/use-selected-source-institution';
import useTranslation from 'hooks/use-translation';

export default function CourseSearch(): JSX.Element {
  const { selectedSourceInstitution } = useSelectedSourceInstitution();
  const { searchTerm, setSearchTerm } = useCourseSearchStore();
  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }

  const prefix = translation.common.icons.courseSearchPrefix ? (
    <img
      src={`./config/icons/${translation.common.icons.courseSearchPrefix.src}`}
      alt=''
      role='presentation'
      width={18}
      height={18}
    />
  ) : (
    <BookOpenIcon size={18} />
  );

  const suffix = searchTerm.length > 0 && <XIcon size={24} onClick={() => setSearchTerm('')} />;

  return (
    <RoundedInput
      disabled={!selectedSourceInstitution}
      aria-disabled={!selectedSourceInstitution}
      className='course-search-container'
      title='Course search'
      value={searchTerm}
      prefix={<SearchIconContainer type='prefix'>{prefix}</SearchIconContainer>}
      suffix={<SearchIconContainer type='suffix'>{suffix}</SearchIconContainer>}
      placeholder={translation.home.courseSearch.placeholder}
      onChange={(e) => setSearchTerm(e.target.value)}
      autoComplete='off'
    />
  );
}
